import type flatpickr from 'flatpickr'

import '../flatpickr-calendar.css'

type MutableYearElements = Omit<flatpickr.Instance, 'yearElements' | 'currentYearElement'> & {
  yearElements: Array<HTMLInputElement | HTMLSelectElement>
  currentYearElement: HTMLInputElement | HTMLSelectElement
}

export function replaceFlatpickrYearInputWithDropdown(instance: flatpickr.Instance): void {
  if (instance.config.noCalendar || instance.isMobile || instance.yearElements.length !== 1) return

  const oldInput = instance.yearElements[0]
  const wrapper = oldInput.closest('.numInputWrapper')
  const parent = wrapper?.parentNode
  if (!wrapper || !parent) return

  const nowYear = new Date().getFullYear()
  let minYear = instance.config.minDate?.getFullYear() ?? nowYear - 150
  let maxYear = instance.config.maxDate?.getFullYear() ?? nowYear + 20
  const cy = instance.currentYear
  if (cy < minYear) minYear = cy
  if (cy > maxYear) maxYear = cy
  if (minYear > maxYear) return

  const select = document.createElement('select')
  select.className = ['flatpickr-year-dropdown', oldInput.className].filter(Boolean).join(' ')
  select.tabIndex = oldInput.tabIndex
  const ariaLabel = oldInput.getAttribute('aria-label')
  if (ariaLabel) select.setAttribute('aria-label', ariaLabel)

  for (let y = minYear; y <= maxYear; y++) {
    const opt = document.createElement('option')
    opt.value = String(y)
    opt.textContent = String(y)
    select.appendChild(opt)
  }

  select.value = String(instance.currentYear)

  select.addEventListener('change', () => {
    const y = parseInt(select.value, 10)
    if (!Number.isNaN(y)) instance.changeYear(y)
  })

  parent.replaceChild(select, wrapper)

  const mutable = instance as unknown as MutableYearElements
  mutable.yearElements[0] = select
  mutable.currentYearElement = select

  if (oldInput.disabled) select.disabled = true
}
